/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect, HashRouter } from "react-router-dom";

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss?v1.1.0";

import Index from "views/Index.js";
import Landing from "views/examples/Landing.js";
import Login from "views/examples/Login.js";
import Profile from "views/examples/Profile.js";
import Register from "views/examples/Register.js";
import Homepage from "views/Homepage";
import ProductDetails from "views/ProductDetails";
import Contacts from "views/Contacts";
import './i18n';

ReactDOM.render(
  <HashRouter>
    <Switch>
      <Route path="/components" exact render={props => <Index {...props} />} />
      <Route
        path="/"
        exact
        render={props => <Homepage {...props} />}
      />
      <Route
        path="/product/:productId"
        render={props => <ProductDetails {...props} />}
      />
      <Route
        path="/contacts"
        render={props => <Contacts {...props} />}
      />
      <Redirect to="/" />
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);
